import React, { Component } from 'react';
import { Link } from "react-router-dom";

import ModalWindow from "../../component/common/ModalWindow";
import Shimmer from "../../component/common/Shimmer";
import { getDiscription, getMedicalFileDetail, getMedicalFilesById, getMedicalFileStatus } from './../../actions/FileAction';
import Header from "./../../component/common/Header";
import Loader from "./../../component/common/Loader";
import CONSTANT from "./../../constant";
 
import { getCookie, getDateParts, getStorage } from "../../utils";
import constant from './../../constant';
import AddMedicalComment from './AddMedicalComment';
import { FileListing } from './FileListing';
export default class AppliedMedical extends Component {


    constructor(props) {
        super(props);
        this.state = {
          code: props.match.params.code,
          ud: getCookie(CONSTANT.cookie.userDetail),
          permissions: getStorage(CONSTANT.cookie.permissions),
          detail: undefined,
          list:undefined,
          hrDealingOfficer :"1827" , 
          fileList:undefined, 
          comments: undefined,
          showAddComment: false,
          showLoader: false,
          showTimeLineModal: false,
          timeLineDetails: null,
          levelOne:undefined,
          levelTwo:undefined,
          description:undefined ,
          financeFileStatus : undefined ,
          finallyApproved:undefined
        };
      }

      componentDidMount() {
        ;
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.fileDetail;
        const { code   } = this.props.match.params;
        const { ud   } = this.state;

        getMedicalFileDetail(parseInt(code)).then((res) => {
            
            let medicalList  = res.result;
            let levelOne , levelTwo ; 

              medicalList.map((ele)=>{
               levelOne = ele.levelOne
               levelTwo = ele.levelTwo
               }) 
             
            this.setState({levelOne:levelOne})
            this.setState({levelTwo:levelTwo})
            this.setState({list:res.result})
        });

        getMedicalFilesById(parseInt(code)).then((res) => {
           this.setState({fileList:res.result})
       });
       
        
       getDiscription(parseInt(code)).then((res) => {
          this.setState({description:res.result})
       }); 

      
       getMedicalFileStatus(parseInt(code)).then((res) => {

        let activeUserFileStatus ;
         
         if(ud.code==1785 ){
          if(res.result.length>0){
                res.result.filter((ele)=>{
              if(ele.pendingWith == ud.code && ele.status=="false"){
                activeUserFileStatus = "false"
                 } else{
                activeUserFileStatus = "true"
                 }
            })
             
        }

         }
         else if(ud.code==1799){

          if(res.result.length>0){
              res.result.filter((ele)=>{
              if(ele.pendingWith == ud.code && ele.status=="true"){
                activeUserFileStatus = "false"
                 }
                 else{
                activeUserFileStatus = "true"   
                 }   
            })
        }
         
        if(res.result.length>0){
              res.result.filter((ele)=>{
              if(ele.pendingWith == ud.code && ele.status=="true" && ele.status2=="true" ){
                this.state.finallyApproved = "true"
                 }
                 else{
                  this.state.finallyApproved = "false"   
                 }   
            })
        }

        
         } 
        
         this.setState({financeFileStatus: activeUserFileStatus}) 
         
          }); 

      }


     render() {
      

        const { detail , comments ,list ,fileList , description } = this.state;
        const { showAddComment , showLoader , ud , levelOne , levelTwo   ,financeFileStatus ,
          finallyApproved  } = this.state;        
         let showAddCommentButton = "";
         let showAddCommentButton2 = "";


    
        if (ud.code==getStorage(constant.cookie.hrDealingOfficerList)[0].code||getStorage(constant.cookie.hrexecutive)[0].code )  {
           showAddCommentButton = levelOne ; 
           showAddCommentButton2 = levelTwo ; 
          }

           

    

  
    return (

  
        <React.Fragment>
         
          {
              
            this.state.ud.code==getStorage(CONSTANT.cookie.hrexecutive)[0].code  ||  getStorage(CONSTANT.cookie.finance).some(ele=> ele.code==this.state.ud.code) ?           
            <React.Fragment>
              <div className='container-fluid'>
                 <div className='row'>
                 {/* <div className="col-md-2 px-0">
                    <Header />
                </div> */}
    
                <div className="col-md-12">
                <div className="row my-3">
                  <div className="col-md-8">
                    <h1 className="page-title"> Medical Desk</h1>
                  </div>
                  <div className="col-md-4">
                    <Link
                      to={CONSTANT.component.userFileList.url}
                      className="btn btn-sm btn-link float-right"
                    >
                      Go Back
                    </Link>
                    <button
                      onClick={this.onPrint}
                      className="btn btn-sm btn-link float-right"
                    >
                      <i className="fa fa-print" /> Print
                    </button>
                  </div>
                </div>
                <div className="row">
                {/*  <div className="col-md-12">
                    {detail === undefined && <Shimmer />}
                    {detail !== undefined && this.renderDetail()}
                    {detail !== undefined &&
                      comments !== undefined &&
                      this.renderComments() }
                    {detail !== undefined && this.renderFileClosedSection()}
                    {detail !== undefined && this.renderRecallFileSection()}
                    </div>  */}
                </div>
    
    
    
                <div className="col-md-12 ">
                 
                <div className="list-container">
    
                 
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr>
                                <th scope="col" style={{ width: '3%' }}>#</th>
                                <th scope="col">Category</th>
                                <th scope="col">Category Value </th>
                                <th scope="col">Patient Names</th>
                                <th scope="col">Diagnosis </th>
                                <th scope="col">Account Number </th>
                                <th scope="col">Bank Name </th>
                                <th scope="col">Consulation charges    </th>
                                <th scope="col">Medicine charges    </th>
                                <th scope="col">Pathological Charges </th>
                                <th scope="col">Modified By  </th>
                            </tr>
                             
                                 {list === undefined && <tr>
                                     <td colSpan={5} className="text-center">Loading...</td>
                                 </tr>    
                              }
                             
                                {  list !== undefined && list.length === 0 && <tr>
                                 <td colSpan={5} className="text-center">No records found</td>
                                </tr>}
                             
                            
                            {
                                list !== undefined && list.map((item, index) => {
                                    // const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                    const dated = getDateParts(item.modifiedBy) ; 
                                    return (
                                        <tr key={index} className="c-pointer" 
                                        // onClick={() => this.openDetailPage(detailPageURL)}  
                                        >
                                            <td>{index + 1}</td>
                                            <td className="fw-bold">{item.category} </td>
                                            <td>{item.categoryValue} </td>
                                            <td>{ item.patientNames.toString().split(",").map((ele=> ele.replace(/[^a-zA-Z ]/g, "").trim() )).
                                            map((names)=>{
                                              return (
                                                <React.Fragment>
                                                <span class="badge badge-info mx-1 ">{names}</span>
                                                </React.Fragment>
                                              )
                                            }) } </td>
                                            <td>{item.diagnosis} </td>
                                            <td>{item.accountNumber} </td>
                                            <td>{item.bankName} </td>
                                            <td>{item.consultationCharges} </td>
                                            <td>{item.medicineCost} </td>
                                            <td>{item.pathologicalCharges} </td>
                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                        </tr>
                                    )
                                })  
                            }
                        
                         </tbody>
                    </table>
    
                    <table className="table table-bordered table-hover">
                    <tbody>
                        <tr>
                            <th scope="col" style={{ width: '3%' }}>#</th>
                            <th scope="col"> Physiotherapy Charges  </th>
                            <th scope="col">Operational Charges </th>
                            <th scope="col">Operation Theatre Charges </th>
                            <th scope="col">Anaesthesia Charges   </th>
                            <th scope="col">Room ICU Charges  </th>
                            <th scope="col">Injection Charges  </th>
                            <th scope="col">Disposal Charges     </th>
                            <th scope="col">Dental Charges     </th>
                            <th scope="col">Other Charges  </th>
                            <th scope="col"> Total  </th>
                        </tr>
                         
                             {list === undefined && <tr>
                                 <td colSpan={5} className="text-center">Loading...</td>
                             </tr>    
                          }
                         
                            {  list !== undefined && list.length === 0 && <tr>
                             <td colSpan={5} className="text-center">No records found</td>
                            </tr>}
                         
                        {
                            list !== undefined && list.map((item, index) => {
                                // const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                const dated = getDateParts(item.modifiedBy) ; 
                                return (
                                    <tr key={index} className="c-pointer" 
                                    // onClick={() => this.openDetailPage(detailPageURL)}  
                                    >
                                        <td> </td>
                                        <td className="fw-bold">{item.physiothrapyCharges} </td>
                                        <td>{item.operationCharges} </td>
                                        <td>{item.operationTheatreCharges} </td>
                                        
                                        <td>{item.anaesthesiaCharges} </td>
                                        <td>{item.roomIcuCharges} </td>
                                        <td>{item.injectionCharges} </td>
                                        <td>{item.disposalCharges} </td>
                                        <td>{item.dentalCharges} </td>
                                        <td>{item.otherCharges} </td>
                                        <td>{item.totalSum} </td>
                                    </tr>
                                )
                            })  
                        }
                        
                    </tbody>
                </table>
    
                  <div className='col-12' > 
                        
                   <FileListing fileList={fileList} chargesType={"consultationCharges"} />
                   <FileListing fileList={fileList} chargesType={"medicineCost"} />
                   <FileListing fileList={fileList} chargesType={"pathologicalCharges"} />
                   <FileListing fileList={fileList} chargesType={"physiothrapyCharges"} />
                   <FileListing fileList={fileList} chargesType={"operationCharges"} />
                   <FileListing fileList={fileList} chargesType={"operationTheatreCharges"} />
                   <FileListing fileList={fileList} chargesType={"anaesthesiaCharges"} />
                   <FileListing fileList={fileList} chargesType={"roomIcuCharges"} />
                   <FileListing fileList={fileList} chargesType={"injectionCharges"} />
                   <FileListing fileList={fileList} chargesType={"disposalCharges"} />
                   <FileListing fileList={fileList} chargesType={"dentalCharges"} />
                   <FileListing fileList={fileList} chargesType={"otherCharges"} />
                   </div>            
    
    
                </div>
    
    
    
    
                {/* <div className="card alert-info mb-3">
                  
                <div className="card-header">Additional Info</div>
                <div className="card-body">
                  <div className="row">
                   
                    {/*detail.department.length > 0 && (
                      <div className="col">
                        <b>Departments Sequence</b>
                        <br />
                        {  detail.department.map(function (
                          dept,
                          index
                        ) {
                          return (
                            <span
                              key={index}
                              className="badge badge-primary mr-1"
                            >
                              {dept.name}
                            </span>
                          );
                        })}
                      </div>
                      ) */}
                    
                    { /* detail.detail.financialImplication && (
                      <div className="col">
                        <b>Financial implication </b>
                        <br />
                        {`${CONSTANT.static.currencySymbol} ${parseFloat(
                          detail.detail.financialImplication
                        ).toLocaleString(CONSTANT.static.locale)}`}
                      </div>
                        ) */}
                     
                    {/* detail.approvers.length > 0 && (
                      <div className="col">
                        <b>Approver</b>
                        <br />
                        {detail.approvers
                          .map((item) => item.name)
                          .join(", ")}
                      </div>
                        ) 
                     
                    {
                       
                      <div className="col"> 
                          
                        <CommandBarButton
                          onClick={() =>
                            this.setState({ showTimeLineModal: true })
                          }
                          style={{ backgroundColor: "transparent" }}
                          text="View Timeline"
                        />
    
                         
                      </div>
                    
                    }
                  </div>
                </div>
                  </div> */} 
    
    
    
    
              {/* render comments  */} 
    
    
              <div className="row">
              <div className="col-md-12">
    
                 {
                  description !== undefined  ?
                  this.renderComments(description):<Shimmer /> 
                }
              </div>
            </div>
            {/* render comments */}
              </div>
               
         </div>
            </div>
               </div>





               
              { showAddComment &&  (
                
                 <ModalWindow
                  title="Add comment"
                  backdrop="static"
                  className="modal-lg"
                  toggleModal={this.toggleAddComment} 
                  >
      
                {( list.length && fileList.length )!=0 && 
                  
                 <AddMedicalComment 
                  medicalData = {list}
                  medicalFileList ={fileList} 
                  redirect={this.props.match}  
                 />
                   
                } 
                </ModalWindow>
              )}
                
         
              {
                showAddCommentButton2=='false'  || (financeFileStatus == 'false'&& finallyApproved=='false') || (financeFileStatus == 'false'&& finallyApproved==undefined)    ?  (
                <button
                  className="comment-button bg-primary text-white btn btn-sm"
                  onClick={()=> this.setState({showAddComment:true})  }
                >  Add Comment   </button>
             ) :"" 
          
          }
    
             
             </React.Fragment>

              
            : 

            <div className="container-fluid">
    
            <div className="row">
              <div className="col-md-2 px-0">
                <Header />
              </div>
              <div className="col-md-10">
                <div className="row my-3">
                  <div className="col-md-8">
                    <h1 className="page-title"> Medical Desk</h1>
                  </div>
                  <div className="col-md-4">
                    <Link
                      to={CONSTANT.component.userFileList.url}
                      className="btn btn-sm btn-link float-right"
                    >
                      Go Back
                    </Link>
                    <button
                      onClick={this.onPrint}
                      className="btn btn-sm btn-link float-right"
                    >
                     
                      <i className="fa fa-print" /> Print
                    </button>
                  </div>
                </div>
                <div className="row">
                    {/*
                    
                    <div className="col-md-12">
                    {detail === undefined && <Shimmer />}
                    {detail !== undefined && this.renderDetail()}
                    {detail !== undefined &&
                      comments !== undefined &&
                      this.renderComments() }
                    {detail !== undefined && this.renderFileClosedSection()}
                    {detail !== undefined && this.renderRecallFileSection()}
                    </div>

                  */}

                </div>
    
    
    
                <div className="col-md-12 ">
                 
                <div className="list-container">
    
                 
                    <table className="table table-bordered table-hover">
                        <tbody>
                            <tr>
                                <th scope="col" style={{ width: '3%' }}>#</th>
                                <th scope="col">Category</th>
                                <th scope="col">Category Value </th>
                                <th scope="col">Patient Names</th>
                                <th scope="col">Diagnosis </th>
                                <th scope="col">Account Number </th>
                                <th scope="col">Bank Name </th>
                                <th scope="col">Consulation charges    </th>
                                <th scope="col">Medicine charges    </th>
                                <th scope="col">Pathological Charges </th>
                                <th scope="col">Modified By  </th>
                            </tr>
                             
                                 {list === undefined && <tr>
                                     <td colSpan={5} className="text-center">Loading...</td>
                                 </tr>    
                              }
                             
                                {  list !== undefined && list.length === 0 && <tr>
                                 <td colSpan={5} className="text-center">No records found</td>
                                </tr>}
                             
                            
                            {
                                list !== undefined && list.map((item, index) => {
                                    // const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                    const dated = getDateParts(item.modifiedBy) ; 
                                    return (
                                        <tr key={index} className="c-pointer" 
                                        // onClick={() => this.openDetailPage(detailPageURL)}  
                                        >
                                            <td>{index + 1}</td>
                                            <td className="fw-bold">{item.category} </td>
                                            <td>{item.categoryValue} </td>
                                            <td>{ item.patientNames.toString().split(",").map((ele=> ele.replace(/[^a-zA-Z ]/g, "").trim() )).
                                            map((names)=>{
                                              return (
                                                <React.Fragment>
                                                <span class="badge badge-info mx-1 ">{names}</span>
                                                </React.Fragment>
                                              )
                                            }) } </td>
                                            <td>{item.diagnosis} </td>
                                            <td>{item.accountNumber} </td>
                                            <td>{item.bankName} </td>
                                            <td>{item.consultationCharges} </td>
                                            <td>{item.medicineCost} </td>
                                            <td>{item.pathologicalCharges} </td>
                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                        </tr>
                                    )
                                })  
                            }
                        
                         </tbody>
                    </table>
    
                    <table className="table table-bordered table-hover">
                    <tbody>
                        <tr>
                            <th scope="col" style={{ width: '3%' }}>#</th>
                            <th scope="col"> Physiotherapy Charges  </th>
                            <th scope="col">Operational Charges </th>
                            <th scope="col">Operation Theatre Charges </th>
                            <th scope="col">Anaesthesia Charges   </th>
                            <th scope="col">Room ICU Charges  </th>
                            <th scope="col">Injection Charges  </th>
                            <th scope="col">Disposal Charges     </th>
                            <th scope="col">Dental Charges     </th>
                            <th scope="col">Other Charges  </th>
                            <th scope="col"> Total  </th>
                        </tr>
                         
                             {list === undefined && <tr>
                                 <td colSpan={5} className="text-center">Loading...</td>
                             </tr>    
                          }
                         
                            {  list !== undefined && list.length === 0 && <tr>
                             <td colSpan={5} className="text-center">No records found</td>
                            </tr>}
                         
                        {
                            list !== undefined && list.map((item, index) => {
                                // const detailPageURL = CONSTANT.component.medicalClaimList.url.replace(':code', item.id );
                                const dated = getDateParts(item.modifiedBy) ; 
                                return (
                                    <tr key={index} className="c-pointer" 
                                    // onClick={() => this.openDetailPage(detailPageURL)}  
                                    >
                                        <td> </td>
                                        <td className="fw-bold">{item.physiothrapyCharges} </td>
                                        <td>{item.operationCharges} </td>
                                        <td>{item.operationTheatreCharges} </td>
                                        
                                        <td>{item.anaesthesiaCharges} </td>
                                        <td>{item.roomIcuCharges} </td>
                                        <td>{item.injectionCharges} </td>
                                        <td>{item.disposalCharges} </td>
                                        <td>{item.dentalCharges} </td>
                                        <td>{item.otherCharges} </td>
                                        <td>{item.totalSum} </td>
                                    </tr>
                                )
                            })  
                        }
                        
                    </tbody>
                </table>
    
                  <div className='col-12' > 
                        
                   <FileListing fileList={fileList} chargesType={"consultationCharges"} />
                   <FileListing fileList={fileList} chargesType={"medicineCost"} />
                   <FileListing fileList={fileList} chargesType={"pathologicalCharges"} />
                   <FileListing fileList={fileList} chargesType={"physiothrapyCharges"} />
                   <FileListing fileList={fileList} chargesType={"operationCharges"} />
                   <FileListing fileList={fileList} chargesType={"operationTheatreCharges"} />
                   <FileListing fileList={fileList} chargesType={"anaesthesiaCharges"} />
                   <FileListing fileList={fileList} chargesType={"roomIcuCharges"} />
                   <FileListing fileList={fileList} chargesType={"injectionCharges"} />
                   <FileListing fileList={fileList} chargesType={"disposalCharges"} />
                   <FileListing fileList={fileList} chargesType={"dentalCharges"} />
                   <FileListing fileList={fileList} chargesType={"otherCharges"} />
                   </div>            
    
    
                </div>
    
    
    
    
                {/* <div className="card alert-info mb-3">
                  
                <div className="card-header">Additional Info</div>
                <div className="card-body">
                  <div className="row">
                    {/*detail.department.length > 0 && (
                      <div className="col">
                        <b>Departments Sequence</b>
                        <br />
                        {  detail.department.map(function (
                          dept,
                          index
                        ) {
                          return (
                            <span
                              key={index}
                              className="badge badge-primary mr-1"
                            >
                              {dept.name}
                            </span>
                          );
                        })}
                      </div>
                      ) */}
                    
                    { /* detail.detail.financialImplication && (
                      <div className="col">
                        <b>Financial implication </b>
                        <br />
                        {`${CONSTANT.static.currencySymbol} ${parseFloat(
                          detail.detail.financialImplication
                        ).toLocaleString(CONSTANT.static.locale)}`}
                      </div>
                        ) */}
                     
                    {/* detail.approvers.length > 0 && (
                      <div className="col">
                        <b>Approver</b>
                        <br />
                        {detail.approvers
                          .map((item) => item.name)
                          .join(", ")}
                      </div>
                        ) 
                     
                    {
                       
                      <div className="col"> 
                          
                        <CommandBarButton
                          onClick={() =>
                            this.setState({ showTimeLineModal: true })
                          }
                          style={{ backgroundColor: "transparent" }}
                          text="View Timeline"
                        />
    
                         
                      </div>
                    
                    }
                  </div>
                </div>
              </div> }
    
    
    
    
              {/* render comments  */} 
    
    
              <div className="row">
              <div className="col-md-12">
              
              {
                description !== undefined  ?
                this.renderComments(description):<Shimmer /> 
              }

              </div>
            </div>
    
            {/* render comments */}

            </div>
    
          </div>
               
    
    
            </div>
             
            {showLoader && <Loader />}
    
    
    
    {/* {
    detail!=undefined && detail.detail.code==10914?
    <>
    <ModalWindow
                title="Add comment"
                backdrop="static"
                className="modal-lg"
                toggleModal={this.toggleAddComment}
              >
    
                <AddComment
                  nextlevelReviewers={detail.nextlevelReviewers}
                  pendingWith={detail.pendingWith}
                  detail={detail.detail}
                  approver={detail.approvers}
                  onSubmit={this.onAddComment}
                  toggleModal={this.toggleAddComment}
                />
    
              </ModalWindow> 
              <button
                className="comment-button bg-primary text-white btn btn-sm"
                onClick={this.toggleAddComment}
              >
                Add Comment
              </button>
              </>
              
              :""  
    } */}
    
            
            { /* showAddComment && (
               
              <ModalWindow
                title="Add comment"
                backdrop="static"
                className="modal-lg"
                toggleModal={this.toggleAddComment}
              >
    
                <AddComment
                  nextlevelReviewers={detail.nextlevelReviewers}
                  pendingWith={detail.pendingWith}
                  detail={detail.detail}
                  approver={detail.approvers}
                  onSubmit={this.onAddComment}
                  toggleModal={this.toggleAddComment}
                />
    
              </ModalWindow>
            )   */}
              
       
            {/*
            
              showAddCommentButton  &&  (
              <button
                className="comment-button bg-primary text-white btn btn-sm"
                onClick={this.toggleAddComment}
              > Add Comment   </button>
              )   */ }
             
    
      
    
              {showAddComment &&  (
                 
                <ModalWindow
                  title="Add comment"
                  backdrop="static"
                  className="modal-lg"
                  toggleModal={this.toggleAddComment}
                >
      
                {  (list.length && fileList.length)!=0 && 
                  <AddMedicalComment 
                  medicalData = {list}
                  medicalFileList ={fileList}
                  redirect={this.props.match}  

                 />
                   
                } 
              

                </ModalWindow>
              )}
                
         
              {
                 
                (showAddCommentButton=='false' && ud.code==this.state.hrDealingOfficer) ||  financeFileStatus=='false' ?  (
                <button
                  className="comment-button bg-primary text-white btn btn-sm"
                  onClick={()=> this.setState({showAddComment:true})  }
                > Edit Medical   </button>
             )  : "" 
              
             }
    
              </div>

          }
        
         </React.Fragment>
       
    );
  }



  toggleAddComment = () => {
    this.setState({ showAddComment: !this.state.showAddComment });
  };




  renderComments  = (comments)=>{
  return (
    <React.Fragment>
     {
      comments && comments.length>0 ?
      comments.map((ele,index)=>{
        return (  
         
          <div className="card comment-file mb-3" key={index}>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 text-center">
                  <div>
                    <span>({index + 1})</span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  
                  {  /* <strong>{item.notingName}</strong>  */}
                   
                </div>

                
                  <div className="col-md-12 text-justify">
                    <div
                    className=" text-truncate"

                      dangerouslySetInnerHTML={{
                        __html:ele.description,
                      }}
                    />
                  </div>
               
              </div>
              <div className="row mt-3">
                <div className="col-md-6"></div>
                <div className="col-md-6 text-right">
                  <span className="fs-12">
                    {ele.name}
                    <br />
                    { /* item.createdByDesignation */}
                    <br />
                    { /* `${commentDt.date} ${commentDt.monthName} ${commentDt.year} ${commentDt.hour}:${commentDt.minute}:${commentDt.seconds} ${commentDt.amOrpm}` */}
                  </span>
                </div>
              </div>
            </div>
             
            {/*commAttachment.length > 0 && (
              <div className="card-footer no-print">
                <div className="row">
                  <div className="col-md-12">
                    <span className="mr-3">Attachment(s)</span>
                     

                  </div>
                </div>
              </div>
            )*/}
             
          </div>
        ) 
       }) :<div class="alert alert-success" role="alert">
  No comments Yet
</div>
     }
     </React.Fragment>
  )
  
}


}


